"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const polaris_1 = require("@shopify/polaris");
const components_1 = require("@/common/components");
const layout_1 = require("@/common/components/layout");
const StyledBottomContainer_1 = require("./StyledBottomContainer");
const StyledContainer_1 = require("./StyledContainer");
const StyledContent_1 = require("./StyledContent");
const Layout = () => {
    const containerRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(polaris_1.Frame, null,
        react_1.default.createElement(StyledContainer_1.StyledContainer, { id: 'dashboard-container', ref: containerRef, style: { height: '100vh' } },
            react_1.default.createElement(layout_1.PolarisTopBar, null),
            react_1.default.createElement(StyledBottomContainer_1.StyledBottomContainer, null,
                react_1.default.createElement(layout_1.PolarisSideNav, null),
                react_1.default.createElement(StyledContent_1.StyledContent, null,
                    react_1.default.createElement(components_1.SuperAdminWarning, null),
                    react_1.default.createElement(components_1.RedoMigrationNotice, null),
                    react_1.default.createElement(react_router_dom_1.Outlet, null))))));
};
exports.Layout = Layout;
